export const MENUS = [
  { title: '학생 이슈 (P)', path: '/academy/issues' },
  { title: '신규 학생 (A)', path: '/academy/new-students' },
  { title: '퇴원/휴원 (T)', path: '/academy/withdrawn-students' },
  { title: '인수인계 (H)', path: '/academy/handovers' },
];

export const ADMIN_MENUS = [
  { title: '수업 관리', path: '/academy/classes' },
  { title: '학생 관리', path: '/academy/students' },
  { title: '선생님 관리', path: '/academy/teachers' },
];

export const ADMIN_PATHS = ADMIN_MENUS.map((m) => m.path);
